module.exports = __webpack_public_path__ + "img/Collision.cb161da5.png";